module.exports = __webpack_public_path__ + "media/application/images/svgs/cloud-drizzle-ff494f86bcd62c93e53eea907f957145.svg";